import Logger from '../lib/logger';
import StorageService from '../lib/storage.service';
import { fromEvent, debounceTime } from 'rxjs';

class PDPCustomizeButton extends HTMLButtonElement {
  #NAME = 'PDPCustomizeButton'
  #abortController
  #subscription

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback > variant-id: ${this.getAttribute('variant-id')}`);
    //
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.addEventListener('click', () => this.#onClick(), { signal });
    /* 
      window.navigation on Chrome 102 and higher, Edge 102 and higher 
      window.navigation will respond to history.replaceState
      theme uses history.replaceState on variant change
      listening to popstate doesn't work
    */
    if (window.navigation) {
      window.navigation.addEventListener('navigate', () => this.#onNavigate(), { signal });
    } else {
      // maybe use MutationObserver instead?
      this.#addSubscription();
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
    this.#subscription?.unsubscribe();
  }

  #addSubscription() {
    Logger.info(`${this.#NAME} > #addSubscription()`);
    this.#subscription?.unsubscribe();
    // variant-selects element changes on variant update
    const variantSelects = document.querySelector('variant-selects');
    // using debounce because event seems to fire several times one click
    this.#subscription = fromEvent(variantSelects, 'click').pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.#onNavigate();
    });
  }

  #onClick() {
    Logger.info(`${this.#NAME} > #onClick`);
    //
    StorageService.save('mobileToggle', '0').save('returnLink', window.location.href);
    window.location.href = `${window.Shopify.routes.root}pages/customizer?product=${this.getAttribute('product-handle')}&variant=${this.getAttribute('variant-id')}`
  }

  #onNavigate() {
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get('variant');
    this.setAttribute('variant-id', variant);
    if (!window.navigation) {
      this.#addSubscription();
    }
    Logger.info(`${this.#NAME} > #onNavigate > variant-id: ${variant}`);
  }

}

customElements.define('pdp-customize-button', PDPCustomizeButton, { extends: 'button' });